import { render, staticRenderFns } from "./growth_level_list.vue?vue&type=template&id=21038f72"
import script from "./growth_level_list.vue?vue&type=script&lang=js"
export * from "./growth_level_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports